import moment from 'moment';
import PDFMerger from 'pdf-merger-js';
import { getAsset } from "../../../services/general";
import { convertBase64ToBlob, downloadable } from '../../../utils/fileUtils';
import { handlers } from '../../../helpers/helpers';

const useReports = (countryCode, reports, settings) => {
  const evalautionType = [
    "Ocupacional",
    "EMPO",
    "EMOA",
    "EMRU",
    "EMRE",
    "EMOR",
  ];

  const downloadOrderPeruExams = async (item, type, occupationalType) => {
    let orderedPrestations = [];
    const patientExams = [
      {
        id: item.id,
        code: item.code,
        department_id: item.department_id,
        document_number: item.document_number,
        last_name: item.last_name,
        names: item.names,
        company_name: item.company_name,
        evaluation_type: item.evaluation_type,
        admission_date: item.admission_date,
      },
      ...item.attached_medical_consultation_ids?.map(attached_exam => ({
        ...attached_exam,
        document_number: item.document_number,
        last_name: item.last_name,
        names: item.names,
        company_name: item.company_name,
        evaluation_type: item.evaluation_type,
        admission_date: item.admission_date,
      })),
    ];
    const annex16 = patientExams?.filter(item => item.code === 'ANEXO16');
    const annex16a = patientExams?.filter(item => item.code === 'ALTURA16A');
    const health = patientExams?.filter(item => item.department_id === 1 && !['ANEXO16', 'ALTURA16A'].includes(item.code));
    const psycology = patientExams?.filter(item => item.department_id === 2);
    if (annex16?.length) {
      orderedPrestations = orderedPrestations.concat(annex16);
    }
    if (annex16a?.length) {
      orderedPrestations = orderedPrestations.concat(annex16a);
    }
    if (annex16?.length || annex16a?.length) {
      orderedPrestations = orderedPrestations.concat([...psycology, ...health]);
    } else if (patientExams?.length) {
      orderedPrestations = orderedPrestations.concat([...health, ...psycology]);
    }
    return downloadMedicalReportMerged(orderedPrestations, type, occupationalType);
  };

  const downloadMedicalReportMerged = async (orderedPrestations, type, occupationalType) => {
    const merger = new PDFMerger();

    let pdfName = '';
    for await (const exam of orderedPrestations) {
      if (exam.id) {
        const date = moment(exam.admission_date).format('DD-MM-YYYY');
        pdfName = `${exam.document_number} - ${exam.last_name} ${exam.names} - ${exam.company_name} - ${evalautionType[exam.evaluation_type]} - CMT - ${date}.pdf`;
        const pdf = await getAsset({
          id: exam.id,
          type: 'MedicalConsultationDetail',
          field: 'document'
        });

        const document = await handlers.url2Base64(pdf.document_url);

        const base64 = `data:application/pdf;base64,${document}`;
        await merger.add(convertBase64ToBlob(base64));
      }
    }

    await merger.setMetadata({
      producer: "pdf-merger-js based script"
    });

    const mergedPdf = await merger.saveAsBlob();
    downloadable(mergedPdf, pdfName)
  }

  return {
    downloadOrderPeruExams
  };
};

export default useReports;